import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'searchfilter',
  // pure: false
})
export class SearchPipe implements PipeTransform {

  transform(messages: Array<any>, searchText: string): any[] {
    if (searchText === '') { return messages; }
    return messages.filter( message => {
        if (message.hotelName.toLowerCase().includes(searchText.toLowerCase())) {return true; }
        return false;
    });
   }

}
